/**
 * Radice dell'applicazione.
 *
 * Fa due sole cose: aspetta che il gateway abbia detto in che stato è la
 * sessione, e monta il router. Tutto il resto — quale pagina si vede, dove si
 * viene rimbalzati, quali client delle API sono disponibili — è deciso
 * altrove, e ciascuna di quelle regole si può leggere e provare da sola.
 *
 * Prima qui c'era uno `switch` che sceglieva fra cinque pagine e montava
 * l'unica vista della dashboard: la struttura dell'applicazione stava in venti
 * righe di `if`, e nessuna di quelle viste aveva un indirizzo.
 */

import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { SessionApiProvider } from './api/ApiContext';
import { AppRouter } from './app/AppRouter';
import { useAuth } from './auth/AuthContext';

/**
 * Radice dell'applicazione.
 *
 * @returns L'elemento da montare sotto i provider.
 */
export function App(): JSX.Element {
  const { loading } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    // Markup essenziale di proposito: questa schermata dura il tempo di una
    // richiesta e sta nel chunk iniziale. `Typography` qui costava settanta
    // chilobyte, perché il testo modificabile di antd porta con sé `Input`,
    // `Tooltip` e il motore dei popup.
    return (
      <div className="app-boot">
        <Spin size="small" />
        <span role="status">{t('common.state.checkingSession')}</span>
      </div>
    );
  }

  return (
    <SessionApiProvider>
      <AppRouter />
    </SessionApiProvider>
  );
}
